<section class="form">
  <div class="row">
    <div class="col-md-12 mt-2">
      <i-title [text]="title" [buttons]="buttons"></i-title>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="overflow-y: auto; max-height: 90vh">
      @if (dataMailCreation?.isAnswerMode === false) {
        <app-courrier-edition-form
          [createNewCourrierForIDelibe]="createNewCourrierForIDelibe"
          [mailType]="dataMailCreation?.mailType"
          (isFormValid)="receiveFormValidSt($event)"
          [globalSubmitE]="globalSubmitESubject.asObservable()"
          (canSubmit)="canSubmitReceived($event)"
          (formChange)="onFormChangeEvent($event)"
          (newMail)="receiveNewMail($event)"
          (mailModeEvent)="receiveMailMode($event)"
          (tabEvent)="receiveTabs($event)"
          (formState)="receiveFormState($event)"
          (linkIdEvent)="receiveLinkMailId($event)"
          [mailMode]="dataMailCreation?.mailMode"
          [isNew]="dataMailCreation?.isNew"
          [isAnswerMode]="false">
        </app-courrier-edition-form>
      }

      @if (dataMailCreation?.isAnswerMode) {
        <app-courrier-edition-form
          (isFormValid)="receiveFormValidSt($event)"
          [isNew]="dataMailCreation?.isNew"
          [globalSubmitE]="globalSubmitESubject.asObservable()"
          (canSubmit)="canSubmitReceived($event)"
          (formChange)="onFormChangeEvent($event)"
          (formState)="receiveFormState($event)"
          [mailId]="dataMailCreation?.mailId"
          [isAnswerMode]="dataMailCreation?.isAnswerMode"
          (newMail)="receiveNewMail($event)"
          [expediteurId]="dataMailCreation?.expediteurId"
          [mailType]="dataMailCreation?.mailType">
        </app-courrier-edition-form>
      }
    </div>
  </div>
</section>
